import { isTelegram } from './telegram';
import { historyService } from './history';

/** Чем больше z — тем «выше» слой; Back закрывает верхний открытый. */
export const TG_OVERLAY_Z = {
  verseSelection: 80,
  headerMenu: 100,
  bfMenu: 200,
  chapterSelector: 300,
  history: 400,
  bfReadingSettings: 500,
  settingsModal: 600,
  parallel: 700,
  aiInterpretation: 800,
  verseInsight: 850,
  bookmarks: 900,
  addBookmark: 1000,
  contextSearch: 1100,
  chatPopup: 1200,
  verseImage: 1300,
  languagePrompt: 1400,
  loginPopup: 1500,
  chatRoute: 1600,
};

const overlays = new Map();
let historyBackHandler = null;
let backHandlerInstalled = false;
let backClickHandler = null;

function getWebApp() {
  if (typeof window === 'undefined') return null;
  return window.Telegram?.WebApp || null;
}

function getTopOverlay() {
  let top = null;
  overlays.forEach((entry) => {
    if (!top || entry.z > top.z) top = entry;
  });
  return top;
}

export function canTelegramHistoryBack() {
  if (historyService.canGoBack()) return true;
  if (typeof window === 'undefined') return false;
  return window.history.length > 1;
}

function shouldShowTelegramBack() {
  if (!isTelegram()) return false;
  return overlays.size > 0 || canTelegramHistoryBack();
}

function runTelegramBackAction() {
  const top = getTopOverlay();
  if (top) {
    try {
      top.close();
    } catch {
      /* no-op */
    }
    refreshTelegramBackButton();
    return;
  }
  historyBackHandler?.();
  refreshTelegramBackButton();
}

function installBackHandlerOnce() {
  const tg = getWebApp();
  if (!tg?.BackButton || backHandlerInstalled) return;
  try {
    backClickHandler = () => runTelegramBackAction();
    try {
      tg.BackButton.offClick(backClickHandler);
    } catch {
      /* SDK без offClick */
    }
    tg.BackButton.onClick(backClickHandler);
    backHandlerInstalled = true;
  } catch {
    /* старые клиенты */
  }
}

function refreshTelegramBackButton() {
  const tg = getWebApp();
  if (!tg?.BackButton) return;
  installBackHandlerOnce();
  if (shouldShowTelegramBack()) {
    try {
      tg.BackButton.show();
    } catch {
      /* no-op */
    }
  } else {
    try {
      tg.BackButton.hide();
    } catch {
      /* no-op */
    }
  }
}

/**
 * Регистрирует выезжающую панель / модалку. При isOpen=false снимает с стека.
 * @param {string} id
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {number} [zIndex]
 */
export function syncTelegramOverlay(id, isOpen, onClose, zIndex = 0) {
  if (!isTelegram()) return;
  if (isOpen && typeof onClose === 'function') {
    overlays.set(id, { close: onClose, z: zIndex });
  } else {
    overlays.delete(id);
  }
  refreshTelegramBackButton();
}

export function clearTelegramOverlays() {
  overlays.clear();
  refreshTelegramBackButton();
}

/** Вызывается из React Router (внутри BrowserRouter). */
export function setTelegramHistoryBackHandler(handler) {
  historyBackHandler = typeof handler === 'function' ? handler : null;
  refreshTelegramBackButton();
}

export function notifyTelegramBackStackChanged() {
  refreshTelegramBackButton();
}
